import { RESET_DEFAULT_LANGUAGE, SET_DEFAULT_LANGUAGE } from "../types"

export const setDefaultLanguage = (language) => {
    return {
        type: SET_DEFAULT_LANGUAGE,
        payload: language,
    }
}

export const resetDefaultLanguage = () => {
    return {
        type: RESET_DEFAULT_LANGUAGE,
    }
}
